import clsx from "clsx";

const presets = {
  purple: "bg-violet-500/15 text-violet-400 border-violet-500/30",
  cyan:   "bg-cyan-500/15   text-cyan-400   border-cyan-500/30",
  pink:   "bg-pink-500/15   text-pink-400   border-pink-500/30",
  gold:   "bg-yellow-500/15 text-yellow-400 border-yellow-500/30",
  green:  "bg-green-500/15  text-green-400  border-green-500/30",
  red:    "bg-red-500/15    text-red-400    border-red-500/30",
  gray:   "bg-gray-500/15   text-gray-400   border-gray-500/30",
};

export default function Badge({ children, color = "purple", className = "" }) {
  return (
    <span className={clsx(
      "inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-bold border",
      presets[color] || presets.purple,
      className
    )}>
      {children}
    </span>
  );
}
